import { SpoGendersResponse, SpoSportsResponse } from '@spo/types';
import { ArchiHeaderNewSettings } from './ArchiHeaderNewSettings';
import { ArchiHeaderSettings } from './ArchiHeaderSettings';

export interface ArchiHeaderBalancerProps {
  isSportDataLoading: boolean;
  sportData: SpoSportsResponse;
  genderData: SpoGendersResponse;
  sportId: number;
}

export const ArchiHeaderBalancer = ({
  isSportDataLoading,
  sportData,
  genderData,
  sportId,
}: ArchiHeaderBalancerProps) =>
  sportData[0]?.configuration ? (
    <ArchiHeaderSettings
      isSportDataLoading={isSportDataLoading}
      chosenGenderIds={sportData[0].configuration.genders}
      allGenders={genderData}
      sportId={sportId}
    />
  ) : (
    <ArchiHeaderNewSettings
      isSportDataLoading={isSportDataLoading}
      sportData={sportData}
      allGenders={genderData}
      sportId={sportId}
    />
  );
